import { FC } from 'react';
import Box from '@mui/material/Box';
import { ReactComponent as SlackIcon } from '../../../../assets/icons/slack.svg';
import {
  Autocomplete,
  AutocompleteChangeReason,
  FormControl,
  FormHelperText,
  TextField,
  Theme,
  Typography,
  createFilterOptions,
} from '@mui/material';
import { Nullable } from 'common-types';
import { Channel } from '../../../../slack/types/slack-types';

const SendSlackMessgeContent: FC<
  React.PropsWithChildren<SendSlackMessgeContentProps>
> = ({
  error = '',
  channels,
  selectedChannel,
  userComment,
  onSelectedChannelChange,
  onTextAreaChange,
}) => {
  return (
    <Box
      gap={1}
      flexDirection='column'
      display='flex'
      mb={1}
      alignItems='start'>
      <Box width={'100%'} flexDirection='row' display='flex' alignItems='start'>
        <div>
          <SlackIcon height={50} width={50} />
        </div>
        <Box flex={1} display='flex' flexDirection='column' alignItems='start'>
          <Typography variant='h6' ml={1}>
            Select Channel
          </Typography>
          <Typography variant='body2' ml={1}>
            Send OX Alerts directly to your public Slack channel
          </Typography>
        </Box>
        <Box alignSelf='flex-end' width={200}>
          <FormControl required={true} size='small' fullWidth>
            <Autocomplete
              autoComplete
              filterOptions={createFilterOptions({
                matchFrom: 'any',
                stringify: option => option.name,
              })}
              isOptionEqualToValue={(option, value) => {
                return option.name === value.name;
              }}
              options={channels || []}
              getOptionLabel={option => option.name}
              renderInput={params => (
                <TextField
                  {...params}
                  required
                  placeholder='Channel Name'
                  size='small'
                  hiddenLabel
                  color='primary'
                  name='slack-channel'
                  label='Public Channels'
                  error={!!error}
                  fullWidth
                />
              )}
              aria-required
              sx={(theme: Theme) => ({
                '& .MuiOutlinedInput-input': {
                  paddingLeft: theme.spacing(1),
                },
              })}
              placeholder='Channel Name'
              value={selectedChannel}
              onChange={onSelectedChannelChange}
              size='small'
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <Typography color='text.primary' variant='body2'>
                    {option.name}
                  </Typography>
                </li>
              )}
            />
            <FormHelperText required error filled>
              {!!error ? error : ''}
            </FormHelperText>
          </FormControl>
        </Box>
      </Box>
      <FormControl size='small' fullWidth>
        <TextField
          value={userComment}
          fullWidth
          multiline
          minRows={2}
          placeholder='Add your own comment ...'
          size='small'
          onChange={onTextAreaChange}
          name='userComment'
          label='(Optional) Add your own comment ...'
        />
      </FormControl>
    </Box>
  );
};

export interface SendSlackMessgeContentProps {
  error?: Nullable<string>;
  channels: Nullable<Channel[]>;
  selectedChannel: Nullable<Channel>;
  userComment: string;
  onTextAreaChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSelectedChannelChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: Nullable<Channel>,
    reason: AutocompleteChangeReason,
  ) => void;
}

export default SendSlackMessgeContent;
